import type { CardId, Seat } from '@ubs/rules';

/**
 * Sabit sayıda yuvaya kart seçme.
 *
 * Gömmede 4, alışverişte hedef başına 1-2 yuva var. Yuva dizisi seçimin
 * KENDİSİ: hangi kartın hangi yuvaya (dolayısıyla alışverişte hangi oyuncuya)
 * gittiği baştan belli oluyor, ayrıca eşleştirme yapmak gerekmiyor.
 *
 * `null` = boş yuva.
 */
export type Slots = (CardId | null)[];

export const emptySlots = (count: number): Slots => new Array<CardId | null>(count).fill(null);

export function toggleSlot(slots: Slots, card: CardId): Slots {
  const existing = slots.indexOf(card);
  if (existing >= 0) {
    const next = [...slots];
    next[existing] = null;
    return next;
  }

  const free = slots.indexOf(null);
  if (free >= 0) {
    const next = [...slots];
    next[free] = card;
    return next;
  }

  /**
   * Yuvalar dolu ve yeni bir karta basıldı: EN ESKİSİ düşüyor.
   *
   * Alternatif "hiçbir şey yapma"ydı ve seçimi değiştirmek için önce bir kartı
   * geri almayı gerektiriyordu — dolu elde parmakla iki adım. Kaydırma
   * davranışı seçimi akıcı bırakıyor.
   */
  return [...slots.slice(1), card];
}

export const filledSlots = (slots: Slots): CardId[] =>
  slots.filter((c): c is CardId => c !== null);

export const slotsReady = (slots: Slots): boolean => slots.every((c) => c !== null);

/** Yuvaların hedeflerine göre gruplanmış hâli — alışveriş mesajının gövdesi. */
export function slotsToGives(
  slots: Slots,
  targets: readonly Seat[],
): { to: Seat; cards: CardId[] }[] {
  const grouped = new Map<Seat, CardId[]>();
  slots.forEach((card, index) => {
    const to = targets[index];
    if (card === null || to === undefined) return;
    const list = grouped.get(to);
    if (list) list.push(card);
    else grouped.set(to, [card]);
  });
  return [...grouped].map(([to, cards]) => ({ to, cards }));
}
